import CryptoJS from 'crypto-js';

// 引入我们刚刚创建的index.js api文件
import indexApi from '@/api/indexApi.js'
import loginApi from '@/api/loginApi.js'
import userApi from '@/api/userApi.js'
import customApi from '@/api/customApi.js'
import mendianApi from '@/api/mendianApi.js'

import config from '@/config'
import cache from "@/plugins/cache"
import { getToken } from '@/utils/auth'

const crypto = require('crypto');
const qs = require('qs');
const is_aes = 1
const aes_token = 'a34bb9e73e35224e17b586d2461116d2';

export default function ({ $axios, app, req, redirect }, inject) {
  function axiosConfig($axios) {
    // 设置API的域名
    $axios.setBaseURL(config.baseUrl)
    // 设置请求拦截
    $axios.onRequest((config) => {
      if (process.client) {
        config.data.domain = window.location.host;
      } else {
        let webSiteIp = req.headers.host.split(':')[0]
        cache.cookie.set(app, "webSiteIp", webSiteIp)
        config.data.domain = webSiteIp
      }
      config.data.user_token = getToken(app) || '';
      let client_token = cache.cookie.get(app, "clientToken")
      if (client_token) {
        config.data.client_token = client_token
      } else {
        if (process.client) {
          const randomValues = window.crypto.getRandomValues(new Uint8Array(16));
          client_token = btoa(String.fromCharCode.apply(null, randomValues));
          client_token = CryptoJS.MD5(client_token).toString();
          cache.cookie.set(app, "clientToken", client_token)
        } else {
          // 生成一个 16 字节的随机缓冲区
          const randomBuffer = crypto.randomBytes(16);
          // 将缓冲区转换为十六进制字符串
          const randomHex = randomBuffer.toString('hex');
          // 生成 MD5 哈希值
          const hash = crypto.createHash('md5');
          hash.update(randomHex);
          client_token = hash.digest('hex');
          cache.cookie.set(app, "clientToken", client_token)
        }
        config.data.client_token = client_token
      }

      if (is_aes > 0 && config.data) {

        var encryptedData = CryptoJS.AES.encrypt(JSON.stringify(config.data), CryptoJS.enc.Utf8.parse(aes_token), {
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7
        });
        config.data = qs.stringify({ 'postdata': encryptedData.toString(), 'is_aes': 1 });
      } else {
        config.data = qs.stringify(config.data)
      }

      config.startTime = new Date().getTime()
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8'
      // setTimeout(()=>{

      // },5000)
      return config
    })
    // 设置响应拦截
    $axios.onResponse((response) => {
      response.config.endTime = new Date().getTime()
      const status = response.status

      if (+status === 200) {
        // 返回接口数据
        if (is_aes > 0 && response.data) {
          const bytes = CryptoJS.AES.decrypt(response.data, CryptoJS.enc.Utf8.parse(aes_token), {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
          });
          return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        } else {
          return response.data
        }
      } else {
        // 如果请求失败的，打印出相应的错误信息，更好的修改。
        const responseConfig = response ? response.config : {}
        console.log('响应拦截报错提示： ', {
          url: responseConfig.baseURL + responseConfig.url,
          status: response.status,
          statusText: response.statusText,
          method: responseConfig.method,
          headers: responseConfig.headers,
          data: responseConfig.data,
          params: responseConfig.params,
          responseData: response.data,
        })
      }
    })
    // 最后返回$axios对象
    return $axios
  }
  inject('indexApi', indexApi(axiosConfig($axios.create())))
  inject('loginApi', loginApi(axiosConfig($axios.create())))
  inject('userApi', userApi(axiosConfig($axios.create())))
  inject('customApi', customApi(axiosConfig($axios.create())))
  inject('mendianApi', mendianApi(axiosConfig($axios.create())))
  

}
